import TopBar from '../components/Topbar'
import JobsList from '../components/TaskList/JobsList'
import '../components/jobui/styles/globals.css'
import '../components/jobui/styles/input.css'

export const JobsHome = () => {
  return (
    <div>
      <TopBar title="Task history" description="" />
      <div className="jobui-globalContainer">
        <JobsList />
      </div>
    </div>
  )
}
